import useSessionStorage from 'use-session-storage-state';

import { useUserEmail } from '../authentication/useAuth';

export const useSessionState = (
	key, // storage key to append to user email
	initialState // same as useState param
) => {
	const email = useUserEmail();
	return useSessionStorage(`${email}_${key}`, {
		defaultValue: initialState,
	});
};
